export default {
  'Text': 'Text',
  'Styles': 'Stile',
  'Text here': 'Text hier',
  'Add subtitles': 'Untertitel hinzufügen',
  'Text Color': 'Textfarbe',
  'Outline': 'Außenhaut',
  'Background': 'Hintergrund',
  'Position': 'Position',
}